import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCarussel: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="carussel, slides"><path fillRule="evenodd" clipRule="evenodd" d="M5.75 3.75C5.75 3.33579 6.08579 3 6.5 3H17.5C17.9142 3 18.25 3.33579 18.25 3.75V5H21.25C21.6642 5 22 5.33579 22 5.75V18.25C22 18.6642 21.6642 19 21.25 19H18.25V20.25C18.25 20.6642 17.9142 21 17.5 21H6.5C6.08579 21 5.75 20.6642 5.75 20.25V19H2.75C2.33579 19 2 18.6642 2 18.25V5.75C2 5.33579 2.33579 5 2.75 5H5.75V3.75ZM5.75 6.5H3.5V17.5H5.75V6.5ZM18.25 17.5H20.5V6.5H18.25V17.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCarussel;
